const APP_STORE_URL = 'https://apps.apple.com/us/app/r8tr/id1483531081';
const PLAY_STORE_URL =
  'https://play.google.com/store/apps/details?id=com.r8tr_app';

const isAppleMobile = (): boolean => {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent;
  if (/iPad|iPhone|iPod/.test(ua)) return true;
  return navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;
};

export const mobileAppStoreUrl = (): string =>
  isAppleMobile() ? APP_STORE_URL : PLAY_STORE_URL;
